import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Phone, Video } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, messageErreur } from "@/lib/api";

const ROLES = { dirigeant: "Dirigeant", responsable: "Responsable", agent: "Agent", confirmateur: "Confirmateur", partenaire: "Partenaire" };

export const BoutonVisio = ({ ficheId, userId, label = "Appel interne", testId = "visio-button", className = "at-btn at-btn-ghost" }) => {
  const nav = useNavigate();
  const [ouvert, setOuvert] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [choix, setChoix] = useState(userId ? [userId] : []);
  const [q, setQ] = useState("");
  useEffect(() => { if (ouvert) api.get("/visio/contacts").then((r) => setContacts(r.data)).catch(() => {}); }, [ouvert]);
  const visibles = [...contacts.filter((c) => choix.includes(c.id)), ...contacts.filter((c) => !choix.includes(c.id) && c.nom.toLowerCase().includes(q.toLowerCase()))];
  const lancer = async (video) => {
    try {
      const { data } = await api.post("/visio", { participants: choix, fiche_id: ficheId, video });
      setOuvert(false);
      nav(`/visio/${data.id}`);
    } catch (e) { toast.error(messageErreur(e)); }
  };
  const basculer = (id) => setChoix((c) => (c.includes(id) ? c.filter((x) => x !== id) : [...c, id]));
  return (
    <>
      <button type="button" onClick={() => setOuvert(true)} className={className} aria-label={label || "Appel interne audio ou vidéo"} data-testid={testId}><Video size={16} />{label}</button>
      <Dialog open={ouvert} onOpenChange={setOuvert}>
        <DialogContent className="at-popover max-w-[calc(100vw-24px)] sm:max-w-md max-h-[85vh] overflow-y-auto" data-testid="visio-dialog">
          <DialogHeader><DialogTitle>Appel interne</DialogTitle><DialogDescription className="text-xs at-muted">Salle Jitsi factice (simulation).</DialogDescription></DialogHeader>
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher une personne" className="at-input" data-testid="visio-search" />
          <ul className="space-y-1">
            {visibles.map((c) => (
              <li key={c.id}>
                <label className="at-soft min-h-[48px] px-3 flex items-center gap-3 cursor-pointer" data-testid={`visio-contact-${c.id}`}>
                  <input type="checkbox" className="w-5 h-5" checked={choix.includes(c.id)} onChange={() => basculer(c.id)} style={{ accentColor: "var(--accent)" }} />
                  <span className="min-w-0 flex-1 truncate font-semibold">{c.nom}</span><span className="text-xs at-muted">{ROLES[c.role]}</span>
                </label>
              </li>
            ))}
          </ul>
          <div className="grid grid-cols-2 gap-2">
            <button type="button" disabled={!choix.length} onClick={() => lancer(false)} className="at-btn at-btn-ghost" data-testid="visio-start-audio"><Phone size={16} />Audio</button>
            <button type="button" disabled={!choix.length} onClick={() => lancer(true)} className="at-btn at-btn-primary" data-testid="visio-start-video"><Video size={16} />Vidéo</button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
